<div class="bg-neutral-700 px-[20px] pt-3 text-white">
  <div>
    <h1 class="pt-2 text-lg font-semibold">Nutridayshop.nutridayquocte.com</h1>
    <span class="text-sm"
      >Nutriday Shop là trang bán hàng với và hàng ngàn sản phẩm đa dạng. Là nơi
      tiêu dùng mua sắm an tâm tiện lợi. Là nơi cung cấp nguồn hàng sỉ-lẻ giá
      giá tốt, chất lượng tốt. Là nơi tạo ra cơ hội việc làm với thu nhập không
      giới hạn. <br />Mã số doanh nghiệp/Mã số thuế: 2700948347, cấp 10/11/2022
      tại Sở Kế hoạch & Đầu tư tỉnh Ninh Bình. Đại diện theo pháp luật: Bùi Văn
      Khang
    </span>
  </div>
  <div>
    <h1 class="pt-2 text-lg font-semibold text-white">
      Chính Sách & Điều Khoản
    </h1>
    <div>
      <!-- [routerLink]="['/products']" href="/footer/ordering-guide" -->
      <a [routerLink]="['/footer/ordering-guide']" class="text-sm">
        Hướng dẫn đặt hàng.
      </a>
    </div>
    <div>
      <a [routerLink]="['/footer/delivery-regulations']" class="text-sm">
        Chính sách giao hàng, kiểm hàng và vận chuyển.</a
      >
    </div>
    <div>
      <a [routerLink]="['/footer/payment-guide']" class="text-sm">
        Hướng dẫn thanh toán
      </a>
    </div>
    <div>
      <a [routerLink]="['/footer/complaint-handling-policy']" class="text-sm">
        Chính sách xử lý khiếu nại</a
      >
    </div>
    <div>
      <a [routerLink]="['/footer/information-security-policy']" class="text-sm">
        Chính sách bảo mật</a
      >
    </div>
  </div>
  <div>
    <h1 class="pt-2 text-lg font-semibold text-white">Liên hệ</h1>
    <span class="text-sm">Công Ty Cổ Phần Quốc Tế Nutriday<br /></span>
    <span class="text-sm">MST: 2700948347<br /></span>
    <span class="text-sm"
      >Địa chỉ: Số 104, Ngõ 6, Đường Phạm Thận Duật, Phố Bắc Sơn, Phường Bích
      Đào, Thành phố Ninh Bình, Tỉnh Ninh Bình, Việt Nam<br
    /></span>
    <span class="text-sm">Hotline: 0856 067 666<br /></span>
    <span class="text-sm">Email: cskhnutridayquocte&#64;gmail.com<br /></span>
  </div>
  <div class="pt-5">
    <a href="http://online.gov.vn/Home/WebDetails/119951">
      <img alt="" title="" src="assets/images/approval/ApprovalImage.png"
    /></a>
  </div>
</div>
